"use client"

import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

interface ProgressProps
  extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> {
  isIndeterminate?: boolean
  size?: "sm" | "md" | "lg"
  color?: "primary" | "green" | "yellow" | "red"
}

const sizeClasses = {
  sm: "h-1",
  md: "h-2",
  lg: "h-4",
}

const colorClasses = {
  primary: "bg-primary",
  green: "bg-green-500",
  yellow: "bg-yellow-500",
  red: "bg-red-500",
}

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  ProgressProps
>(({ className, value, isIndeterminate, size = "md", color = "primary", ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "relative w-full overflow-hidden rounded-full bg-primary/20",
      sizeClasses[size],
      className
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={cn(
        "h-full w-full flex-1 transition-all",
        colorClasses[color],
        isIndeterminate && "animate-progress-indeterminate"
      )}
      style={
        isIndeterminate
          ? undefined
          : { transform: `translateX(-${100 - (value || 0)}%)` }
      }
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
